import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";

import { App } from "./App.js";
import { initSentry } from "./sentry.js";
import { AuthProvider } from "./store/auth.js";
import "./index.css";

initSentry();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found in index.html");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
